import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    displayLabelTranslation: {},
    backendVariableMacroCategory: {},
    backendVariableVariableCategory: {},
    overall: {},
    itm: {},
    itmAndOverall: {},
};

export const dataMappingStore = createSlice({
    name: "dataMappingStore",
    initialState,
    reducers: {
        loadDataMappingDisplayLabelState: (state, action) => {
            state.displayLabelTranslation = action.payload;
        },
        loadDataMappingBackendVariableMacroCategoryState: (state, action) => {
            state.backendVariableMacroCategory = action.payload;
        },
        loadDataMappingBackendVariableVariableCategoryState: (state, action) => {
            state.backendVariableVariableCategory = action.payload;
        },
        loadOverallState: (state, action) => {
            state.overall = action.payload;
        },
        loadItmState: (state, action) => {
            state.itm = action.payload;
        },
        loadItmAndOverallState: (state, action) => {
            state.itmAndOverall = action.payload;
        },
        resetDataMappingStoreState: () => initialState,
    },
});

export const { loadDataMappingDisplayLabelState, loadOverallState, loadItmState, loadItmAndOverallState, loadDataMappingBackendVariableMacroCategoryState, loadDataMappingBackendVariableVariableCategoryState, resetDataMappingStoreState } = dataMappingStore.actions;

export default dataMappingStore.reducer;
